// src/pages/PricingPage.js
import React from 'react';
import { useNavigate } from 'react-router-dom';

// Main Layout Components
import MainNavbar from '../components/MainNavbar';
import MainFooter from '../components/MainFooter';

// --- Import ALL reusable subscription components ---
import { FreeTierCard } from '../components/subscription/FreeTierCard';
import { PricingCards } from '../components/subscription/PricingCards';
import { PremiumGlimpse } from '../components/subscription/PremiumGlimpse';
import { FeatureComparisonTable } from '../components/subscription/FeatureComparisonTable';

function PricingPage() {
  const navigate = useNavigate();

  const handleSelectPlan = () => {
    navigate('/user/register');
  };

  return (
    <div className="flex flex-col min-h-screen bg-background-primary overflow-x-hidden">
      <MainNavbar />
      <main className="flex-grow overflow-x-hidden">
        <div className="max-w-7xl mx-auto py-12 sm:py-16 px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h1 className="text-3xl sm:text-4xl font-extrabold text-content-primary sm:text-5xl tracking-tight">
              Find the Perfect Plan for Your Japanese Journey
            </h1>
            <p className="mt-4 text-lg sm:text-xl text-content-secondary max-w-4xl mx-auto">
              Start with our free tier or unlock the full library with premium.
            </p>
          </div>

          {/* --- 1. Prominently feature the FREE plan first --- */}
          <FreeTierCard onGetStarted={handleSelectPlan} />

          {/* --- 2. Show what the platform offers (both free and premium content) --- */}
          <PremiumGlimpse />

          {/* --- 3. Then, present the PREMIUM options --- */}
          <div className="mt-16 sm:mt-20 text-center">
            <h2 className="text-2xl sm:text-3xl font-extrabold text-content-primary tracking-tight">Ready to Go Premium?</h2>
            <p className="mt-4 text-lg sm:text-xl text-content-secondary max-w-2xl mx-auto">
              Unlock all levels and advanced features with a single upgrade.
            </p>
          </div>
          <PricingCards onSelectPlan={handleSelectPlan} showButtons />

          {/* --- 4. Show the direct comparison to seal the deal --- */}
          <FeatureComparisonTable onSelectPlan={handleSelectPlan} />
        </div>
      </main>
      <MainFooter />
    </div>
  );
}

export default PricingPage;
